<template>
  <HPopup class="h-message"
          ref="popup"
          :visible.sync="visible"
          :z-index="zIndex"
          :close-on-click-modal="false">
    <div class="popup-body">
      <slot>
        <div class="h-message-default-content">
          <p v-for="item in messages" style="margin: 5px 0;">
            {{ item }}
          </p>
        </div>
      </slot>
      <footer class="footer">
        <button ref="button"
                v-click-sound-button
                class="h-button confirm"
                @click="closePopup">
        </button>
      </footer>
    </div>
  </HPopup>
</template>

<style lang="stylus" scoped>
  .h-message
    .popup-body
      width 300px
      .h-message-default-content
        padding 20px 0
        line-height 20px
        font-size 14px
        text-align center
        whiteText1()
      .footer
        margin-top 30px
        text-align center
        button
          outline 2px solid #e8d478

</style>

<script>
  import Bus from '@/assets/js/global-bus'
  import HPopup from '@/components/h-popup/index.vue'

  export default {
    name: 'HMessage',

    beforeDestroy() {
      Bus.off('keyup', this.keyUpHandler)
    },

    data () {
      return {}
    },

    props: {
      visible: {
        type: Boolean,
        default: false
      },
      zIndex: {
        type: Number,
        default: 2000
      },
      message: {
        type: String,
        default: ''
      }
    },

    computed: {
      messages () {
        console.log(this.message)
        console.log(this.message.split(/[\r\n]/g))
        return this.message.split(/[\r\n]/g)
      },
    },

    mounted () {
      Bus.on('keyup', this.keyUpHandler)
    },

    methods: {
      keyUpHandler (e) {
        if (this.visible && e.key === 'Enter') {
          this.$refs.button && this.$refs.button.click()
        }
      },
      closePopup () {
        this.visible = false
      }
    },

    components: {
      HPopup
    }
  }
</script>
